import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import { H6 } from 'components/typography/Headers';
import { TextButton2 } from 'components/typography/TextButtons';
import { Text2 } from 'components/typography/Texts';
import { OrganizationDto } from 'services/payment/paymentService.dto';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid ${theme.color.borderGray};
  border-radius: 10px;
  padding: 10px;
  text-align: start;
`;

const Details = styled(Text2)`
  margin: 10px 0;
  color: ${theme.color.lighterGray2};
`;

const SelectButton = styled(TextButton2)`
  text-align: left;
  padding: 0;
`;

interface Props {
  organization: OrganizationDto;
  onSelected: () => void;
}

const OrganizationTile = ({ organization, onSelected }: Props) => {
  const { t } = useTranslation('myProfile');

  const detailsInfo = `${organization.address.street}, 
  ${organization.address.city}, 
  ${organization.address.state},
  ${organization.address.zip}
  ${t('form-inputs.ein-placeholder')}: ${organization.ein}`;

  return (
    <Container data-testid={'organization-tile'}>
      <H6 data-testid={'organization-tile-name'}>{organization.name}</H6>
      <Details data-testid={'organization-tile-details'}>{detailsInfo}</Details>
      <SelectButton onClick={onSelected}>{t('become-fundraiser.verify-organization.choose-organization')}</SelectButton>
    </Container>
  );
};

export default OrganizationTile;
